import { ResourceTypeId } from '~/client/src/shared/constants/resourceTypes'
import { LocalStorageKey } from '~/client/src/shared/enums/LocalStorageKey'
import { useMaterialResourceStore } from '~/client/src/shared/hooks/useMaterialResourceStore'
import { useResourceRuntimeContext } from '~/client/src/shared/hooks/useResourceRuntimeContext'

import { createResourceProvider } from '../../components/Resource/createResourceProvider'

export const MaterialResourcesProvider = createResourceProvider({
  resourceTypeId: ResourceTypeId.MATERIALS,
  useSource: useMaterialResourceStore,
  columnConfigKey: LocalStorageKey.MaterialsColumnConfig,
  useRuntimeContext: useResourceRuntimeContext,
})
